// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-container {\n  margin: 16px 16px 16px 16px;\n}\n.dashboard-header {\n  color: #3E3E3E;\n  font-family: Gravity-Bold, sans-serif;\n  font-size: 30px;\n  line-height: 36px;\n}\n", ""]);
// Exports
module.exports = exports;
